'use strict';

var App = require('app');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var DeviceFilterView = require('components/devices/views/common/device_filter_view');

module.exports = OOP.extend(Marionette.LayoutView, {
    backgroundTasks: Misc.getBackgroundTaskManager(),
    template: require('components/devices/templates/common/filter_dialog'),
    ui: OOP.inheritedObj('ui', {
        btnSubmit: '#js-success',
    }),
    events: OOP.inheritedObj('events', {
        'click #js-success': function (e) {
            e.preventDefault();
            e.stopPropagation();
            this.options.cb && this.options.cb(this.filterView.getFilter());
        },
    }),
    regions: {
        filter: '.deviceFilter',
    },
    data: {},

    initialize: function (options) {
        this.base.initialize(options);
        this.data.filter = options.filter ? Misc.cloneAsJSON(options.filter) : {};
    },

    createFilter: function () {
        var self = this;
        this.filterView = new DeviceFilterView({
            controller: this.controller,
            fixedCategory: this.options.fixedCategory,
            fixedStatus: this.options.fixedStatus,
            showDeviceCount: true,
            onLoadComplete: function () {
                if (self.options.onLoadComplete) self.options.onLoadComplete();
                self.showChildView('filter', self.filterView);
            },
            onFilterChanged: function () {
                var filter = self.filterView.getFilter();
                self.updateDeviceCount(filter);
            },
            defaultFilter: this.data.filter,
            showDeviceCount: true,
        });
    },

    updateDeviceCount: function (filter) {
        this.ui.btnSubmit.prop('disabled', true);
        var self = this;
        var devicesReq = App.request('device:list', {
            filterParams: { limit: 1, onError: 'emptyList' },
            filter: filter,
        });
        $.when(devicesReq).done(function (result) {
            if (!result) return;

            self.filterView.setDeviceCount(result.count);
            self.ui.btnSubmit.prop('disabled', false);
        });
    },

    onRender: function () {
        $('.modal-dialog').addClass('modal-lg');
    },

    onShow: function () {
        this.createFilter();
    },

    serializeData: function () {
        return {};
    },
});
